class PrestationsAccordion {
	constructor() {
		let cache = {};

		let initFunc = () => {
			initCache();
			if (!cache.items.length) return;
			initEvents();
		};

		let initCache = () => {
			cache.items = document.querySelectorAll('.prestations-list__item');
		};

		let initEvents = () => {
			cache.items.forEach((item) => {
				let header = item.querySelector('.prestations-list__item-header');
				let body = item.querySelector('.prestations-list__item-body');

				header.addEventListener('click', () => {
					if (item.classList.contains('is-active')) {
						closeItem(item, body);
					} else {
						// Close all other items
						cache.items.forEach((otherItem) => {
							if (otherItem !== item && otherItem.classList.contains('is-active')) {
								let otherBody = otherItem.querySelector('.prestations-list__item-body');
								closeItem(otherItem, otherBody);
							}
						});
						openItem(item, body);
					}
				});
			});
		};

		let openItem = (item, body) => {
			item.classList.add('is-active');
			let content = body.querySelector('.prestations-list__item-content');
			let height = content.offsetHeight;
			body.style.height = height + 'px';
		};

		let closeItem = (item, body) => {
			item.classList.remove('is-active');
			body.style.height = '0';
		};

		initFunc();
	}
}

export { PrestationsAccordion };
